import getInitialFilters from './getInitialFilters';

export default getInitialFilters;
